import { render, staticRenderFns } from "./oilQualityMonitoring.vue?vue&type=template&id=9a861cb6&scoped=true"
import script from "./oilQualityMonitoring.vue?vue&type=script&lang=js"
export * from "./oilQualityMonitoring.vue?vue&type=script&lang=js"
import style0 from "./oilQualityMonitoring.vue?vue&type=style&index=0&id=9a861cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a861cb6",
  null
  
)

export default component.exports